import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  priorityBox: {
    width: '100%',
    marginTop: '15px',
    marginBottom: '15px',
  },
  bar: {
    borderRadius: '3px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px 5px 10px',

    '& svg': {
      marginRight: '5px',
    },
  },

  mediumPriority: {
    backgroundColor: '#FEECEB',
  },
  highPriority: {
    backgroundColor: '#BC0000',
    color: 'white',
  },
}));
